import { render } from "./ProjectAttachmentModal.vue?vue&type=template&id=32c63fc1&scoped=true&ts=true"
import script from "./ProjectAttachmentModal.ts?vue&type=script&lang=ts"
export * from "./ProjectAttachmentModal.ts?vue&type=script&lang=ts"

import "./ProjectAttachmentModal.scss?vue&type=style&index=0&id=32c63fc1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c63fc1"]])

export default __exports__